import { render, staticRenderFns } from "./SelectProformProductBlock.vue?vue&type=template&id=99db0936&scoped=true"
import script from "./SelectProformProductBlock.vue?vue&type=script&lang=js"
export * from "./SelectProformProductBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99db0936",
  null
  
)

export default component.exports